export const calculatePipeExcavation = (
  length: number,
  diameter: number,
  depth: number,
  pipeType: 'clay' | 'plastic' = 'clay'
): number => {
  const trenchWidth = Math.max(diameter + 0.3, 0.6);
  const volume = length * trenchWidth * depth;
  
  const wastageMultiplier = pipeType === 'clay' ? 1.15 : 1.1;
  return volume * wastageMultiplier;
};

export const calculateBackfillVolume = (
  excavationVolume: number,
  pipeVolume: number,
  backfillType: 'type1' | '6F2' = 'type1'
): number => {
  const compactionFactor = backfillType === 'type1' ? 1.2 : 1.15;
  return (excavationVolume - pipeVolume) * compactionFactor;
};

export const calculateRoadArea = (
  length: number,
  width: number,
  _thickness: number
): number => {
  return length * width;
};

export const calculateRoadVolume = (
  length: number,
  width: number,
  thickness: number
): number => {
  return length * width * thickness;
};

export const roundToDecimalPlaces = (value: number, decimals: number = 2): number => {
  return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
};

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatQuantity = (value: number, unit: string = ''): string => {
  const formattedValue = roundToDecimalPlaces(value, 2);
  return unit ? `${formattedValue} ${unit}` : formattedValue.toString();
};